import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@material-ui/lab/Skeleton';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';

import Adjunto from '../../commons/Adjunto';
import { useFormularioContext } from '../../commons/Formulario';
import { mensaje, mensajeMini } from '../../commons/Mensajes';
import useMantenimiento from '../../hooks/useMantenimiento';

/**
 * Componente de imagenes de mantenimiento por equipo.
 * @param {object} photos objeto de fotos del mantenimiento
 * @returns MaintenancePhotos
 * @see MaintenancePhotos
 */
const MaintenancePhotos = ({ photos, equipment, onSave }) => {
  const { selected, accionTask, processing } = useFormularioContext();
  const { patchPhoto } = useMantenimiento();
  const [process, setProcess] = useState(false);

  /**
   * Agregar imagen de mantenimiento.
   * @param {any} attached imagen a subir en formato file
   * @param {string} note notas de la imagen
   */
  const handleAddPhoto = async (attached, note) => {
    setProcess(true);
    let response = await patchPhoto({
      so: selected.so,
      eq: equipment.eq.eq,
      ia: accionTask,
      im: attached,
      nt: note ?? '',
    });
    if (response.success && response.status === 'success') {
      mensaje('Operación Satisfactoria');
      onSave();
    } else if (response.messageError) {
      mensajeMini(response.messageError);
    }
    setProcess(false);
  };

  return (
    <div>
      {processing || process ? (
        <>
          <Skeleton variant="rect" width={210} height={50} />
          <Skeleton variant="rect" width={210} height={50} />
          <Skeleton variant="rect" width={210} height={50} />
          <Skeleton variant="rect" width={210} height={50} />
          <Skeleton variant="rect" width={210} height={50} />
        </>
      ) : (
        <>
          <Adjunto
            stateParent={true}
            nameParent={'maintenance'}
            extensions={['jpg', 'jpeg', 'png']}
            data={photos?.dtl?.map((a) => ({
              id: a.cr,
              name: a.na,
              note: a.nt,
              extension: a.ea,
              state: a.st,
            }))}
            file={photos.ar}
            onNew={(documento, note) => handleAddPhoto(documento, note)}
            onSuccess={() => onSave()}
            title={'Fotos del mantenimiento'}
            textNewFile="Nueva foto"
            addButtonText={'Nueva foto'}
            addButtonIcon={() => <AddAPhotoIcon />}
            confirmButtonText={'Agregar foto'}
            confirmButtonIcon={() => <AddAPhotoIcon />}
            showNote
          />
        </>
      )}
    </div>
  );
};

MaintenancePhotos.propTypes = {
  photos: PropTypes.object,
  equipment: PropTypes.object,
  onSave: PropTypes.func,
};

export default MaintenancePhotos;
